// extracted by mini-css-extract-plugin
export default {"imageContainer":"page_imageContainer__3yeNY","title":"page_title__yoPeD","image":"page_image__2o_fc","logo":"page_logo__1Mpvd"};